import { createModel, RematchRootState } from "@rematch/core";
import { KoreModel } from ".";
import { Dispatch } from "redux";
import axios from "axios";

export interface DynamicLabels {
  phoneLabels: object[];
}

const model = {
  name: "dynamicLabels",
  state: {} as DynamicLabels,
  reducers: {
    setData: (currentState: DynamicLabels, data: DynamicLabels) => {
      return { ...currentState, ...data };
    }
  },
  effects: (dispatch: Dispatch) => {
    return {
      async getData(id, state: RematchRootState<KoreModel>) {
        const { data } = await axios.get("/api/phoneNumberLabels");
        let phoneNumberLabels = data.results;

        if (phoneNumberLabels.length > 0) {
          phoneNumberLabels = phoneNumberLabels.map((label) => (state.sessionConfigs?.locale === "fr" ? label.fr : label.en));

          dispatch.dynamicLabels.setData({ phoneNumberLabels: phoneNumberLabels });
        }
      }
    };
  }
};

export const dynamicLabelsModel = createModel<KoreModel>()(model);
